<template>
  <div style="background: white; border-bottom: 2px solid #E9F4FF">
    <v-layout justify-center row wrap v-if="isLoggedIn">
      <v-container ma-0 py-0>
        <v-layout justify-center>
          <v-flex xs12 text-xs-right>
            <router-link :to="{ path: isAdmin ? '/account/manage-teachers' : '/account/manage-students' }" v-if="isLoggedIn && !isClassroom">
              <span style="color: #56544d">Accounts &nbsp;&nbsp;|&nbsp;&nbsp;</span>
            </router-link>
            <router-link :to="{ name: 'logout' }">
              <span style="color: #56544d">Sign out</span>
            </router-link>
          </v-flex>
        </v-layout>
      </v-container>
    </v-layout>
    <v-layout justify-center row wrap>
      <v-container ma-0 pa-0>
        <v-layout justify-center align-center>
          <v-flex v-if="isLoggedIn">
            <v-toolbar class="white" light flat prominent>
              <div class="logo">
                <div style="height:4px" />
                <router-link :to="{ path: '/' }">
                  <img src="@/assets/logo-banner.png" height="30" class="mr-3" alt="Brainingcamp Logo">
                  <img v-if="isH2M" src="@/assets/logo-h2m.png" height="34" alt="Brainingcamp Logo">
                </router-link>
              </div>
              <div v-if="$vuetify.breakpoint.mdAndUp">
                <v-btn
                  small
                  flat
                  secondary
                  href="https://www.brainingcamp.com/resources"
                  target="_blank"
                  v-if="!isClassroom"
                >
                  Resources
                </v-btn>
                <v-btn
                  v-else
                  small
                  flat
                  secondary
                  href="https://www.brainingcamp.com/tutorials"
                  target="_blank"
                >
                  Tutorials
                </v-btn>
                <v-btn
                  small
                  flat
                  secondary
                  v-if="!iosVisitor && !isClassroom && !isH2M"
                  href="https://www.brainingcamp.com/pricing"
                  target="_blank"
                >
                  Pricing
                </v-btn>
                <v-btn
                  small
                  flat
                  secondary
                  v-if="!iosVisitor && !isClassroom && isH2M"
                  href="https://www.brainingcamp.com/hand2mind/pricing"
                  target="_blank"
                >
                  Pricing
                </v-btn>
                <router-link :to="{ path: '/redeem' }" v-if="!iosVisitor && !isClassroom">
                  <v-btn
                    small
                    flat
                    secondary
                  >
                    Redeem
                  </v-btn>
                </router-link>
              </div>
              <v-spacer />
              <div v-if="isLoggedIn && $vuetify.breakpoint.smAndUp">
                <ShareCodeEntryControl />
              </div>
              <div v-if="$vuetify.breakpoint.smAndDown">
                <NavMenu/>
              </div>
            </v-toolbar>
          </v-flex>
          <v-flex v-else>
            <v-toolbar class="white" light flat prominent>
              <div class="logo" v-if="$vuetify.breakpoint.smAndUp">
                <div style="height:4px" />
                <a href="https://www.brainingcamp.com/">
                  <img src="@/assets/logo-banner.png" height="34" class="mr-3">
                  <img v-if="isH2M" src="@/assets/logo-h2m.png" height="34">
                </a>
              </div>
              <div class="logo" v-if="$vuetify.breakpoint.xsOnly">
                <div style="height:4px" />
                <a href="https://www.brainingcamp.com/">
                  <img src="@/assets/logo-banner.png" height="28" class="mr-3">
                  <img v-if="isH2M" src="@/assets/logo-h2m.png" height="34">
                </a>
              </div>
              <div v-if="$vuetify.breakpoint.mdAndUp">
                <v-btn
                  small
                  flat
                  secondary
                  v-if="!iosVisitor && !isClassroom && !isH2M"
                  href="https://www.brainingcamp.com/pricing"
                  target="_blank"
                >
                  Pricing
                </v-btn>
                <v-btn
                  small
                  flat
                  secondary
                  v-if="!iosVisitor && !isClassroom && isH2M"
                  href="https://www.brainingcamp.com/hand2mind/pricing"
                  target="_blank"
                >
                  Pricing
                </v-btn>
                <router-link :to="{ path: '/redeem' }">
                  <v-btn
                    flat
                    secondary
                    v-if="!isClassroom"
                  >
                    Redeem
                  </v-btn>
                </router-link>
              </div>
              <v-spacer />
              <router-link :to="{ name: 'login' }" v-if="!isLoggedIn && $vuetify.breakpoint.xs">
                <v-btn 
                  color="secondary"
                  depressed
                >
                  <span class="foooter--text">Sign In</span>
                </v-btn>
              </router-link>

              <router-link :to="{ name: 'login' }" v-if="!isLoggedIn && $vuetify.breakpoint.smAndUp">
                <v-btn white flat>
                  <span class="foooter--text">Sign In</span>
                </v-btn>
              </router-link>
              
              <router-link :to="{ name: 'register' }" v-if="!isLoggedIn && !isH2M && $vuetify.breakpoint.smAndUp">
                <v-btn flat dark style="background-color: #e91e63">
                  Free 30 Day Trial
                </v-btn>
              </router-link>

              <router-link :to="{ name: 'h2mregister' }" v-if="!isLoggedIn && isH2M && $vuetify.breakpoint.smAndUp">
                <v-btn flat dark style="background-color: #e91e63">
                  Free 60 Day Trial
                </v-btn>
              </router-link>

              <div v-if="$vuetify.breakpoint.xs">
                <NavMenu/>
              </div>
            </v-toolbar>
          </v-flex>
        </v-layout>
      </v-container>
    </v-layout>
  </div>
</template>

<script>
import ShareCodeEntryControl from '@/components/ShareCodeEntryControl'
import NavMenu from '@/components/NavMenu'

export default {
  components: {
    ShareCodeEntryControl,
    NavMenu
  },
  computed: {
    isLoggedIn: function () {
      return this.$store.getters.loggedIn;
    },
    isAdmin: function () {
      if (this.$store.getters.user) {
        return this.$store.getters.user.isAdminUser;
      }
      return false;
    },
    isClassroom: function () {
      if (this.$store.getters.user) {
        return this.$store.getters.user.type === 'classroom';
      }
      return false;
    },
    isH2M: function () {
      if (this.$store.getters.vendor === 'hand2mind') {
        return true;
      }

      return false;
    },
    hasLessonAccess: function () {
      if (this.$store.getters.hasLessonAccess) {
        return true;
      }
      return false;
    },
    iosVisitor: function () {
      if (this.$route.query.referrer === 'ios'){
        return true;
      }

      return false;
    }
  }
}
</script>

<style scoped>
.logo {
  cursor: pointer;
}

.lg {
  font-size: 14px;
  color: #56544d;
  font-weight: 500;
  text-transform: uppercase;
}
</style>
